<script>
    /** @type {'basic'|'basic-negative'|'primary'|'secondary'|'destructive'|'plain'} */
    export let type = "basic";

    /** @type {boolean} */
    export let iconOnly = false;

    /** @type {string} */
    export let id = undefined;

    /** @type {string} */
    export let cssClass = "";

    /** @type {string} */
    export let text = "";

    /** @type {boolean} */
    export let large = false;

    /** @type {boolean} */
    export let disabled = false;

    /** @type {boolean} */
    export let loading = false;

    /** @type {'submit'|'button'|'reset'} */
    export let htmlType = "submit";

    /** @type {'false'|'true'|'menu'|'listbox'|'tree'|'grid'|'dialog'} */
    export let haspopup = undefined;

    /** @type {boolean} */
    export let expanded = undefined;

    /** @type {string | undefined} */
    export let ariaLabel = undefined;

    /** @type {string | undefined} */
    export let describedby = undefined;

    /** @type {string | undefined} */
    export let labelledby = undefined;

    /* SL DESIGN SYSTEM*/

    /** @type {boolean} */
    export let useSL = false;

    /** @type {'solid' | 'outline' | 'link' | 'ghost'} */
    let fill = 'solid';

    /** @type {'secondary' | 'primary' | 'success' | 'warning' | 'danger'} */
    let variant = 'secondary';

    $: size = large ? 'lg' : 'md';
    $: {
        if (type === 'basic'){
            fill = 'outline';
            variant = 'primary';
        }

        if (type === 'basic-negative'){
            fill = 'solid';
            variant = 'secondary';
        }

        if (type ===  'primary'){
            fill = 'solid';
            variant = 'primary';
        }
        if (type === 'secondary'){
            fill = 'outline';
            variant = 'secondary';
        }

        if (type === 'destructive'){
            fill = 'solid';
            variant = 'danger';
        }

        if (type === 'plain'){
            fill = 'ghost';
            variant = 'secondary';
        }
    }

    $: visuallyHidden = iconOnly ? "prom-button__text--hidden" : "";
    $: isLarge = large ? "prom-button--large" : "";
    $: isLoading = loading ? "prom-button--loading" : "";
    $: isActive = !loading && !disabled;
    $: ariaLabelText = ariaLabel
        ? ariaLabel
        : (iconOnly ? text : undefined);
</script>

{#if useSL}
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <sl-button
        {id}
        {size}
        {fill}
        {variant}
        {disabled}
        buttontype={htmlType}
        aria-haspopup={haspopup}
        aria-expanded={expanded}
        aria-label={ariaLabelText}
        aria-labelledby={labelledby}
        aria-describedby={describedby}
        on:click
        on:focus
        on:blur
        on:keyup
        on:keydown
    >
        {text}
    </sl-button>
{:else}
    <button
        aria-haspopup={haspopup}
        aria-expanded={expanded}
        aria-label={ariaLabelText}
        aria-labelledby={labelledby}
        aria-describedby={describedby}
        {id}
        type={htmlType}
        class="prom-button prom-button__{type} {cssClass} {isLoading} {isLarge}"
        {disabled}
        data-active={isActive}
        on:click
        on:focus
        on:blur
        on:keyup
        on:keydown
    >
        <span class="prom-button__text">
            <span class={visuallyHidden}>{text}</span>
        </span>
    </button>
{/if}
